import ButtonSize from '@/Enums/ButtonSize.enum';
import CaptureIcon from '@/components/Icons/CaptureIcon';
import { getDownloadButtonSizeSx } from '@/helpers/buttons';
import { Button } from '@mui/material';
import { useMemo } from 'react';

interface IProps {
  onClick?: () => void;
  size?: ButtonSize;
  disabled?: boolean;
}

export const CapturePDFButton = ({ onClick, size = ButtonSize.Other, disabled }: IProps) => {
  const { buttonSx } = useMemo(() => getDownloadButtonSizeSx(size), [size]);

  return (
    <Button
      onClick={onClick}
      variant='outlined'
      sx={{ ...buttonSx, displayPrint: 'none', minWidth: 'unset' }}
      disabled={disabled}
    >
      <CaptureIcon className='shrink-0 w-[44px]' />
    </Button>
  );
};
